<template>
  <div class="container">
    <input @change="uploadfile" type="file" class="d-none" :id="rnd" />
    <div class="row mt-4">
      <!-- <div class="col-6">
        <button class="btn w-100 btn-warning" @click="clickUploader()">
          <i class="fas fa-file"></i>
          &nbsp;
          <i>انتخاب </i>
        </button>
      </div>
      <div class="col-6">
        <div class="w-100 uploaderbox Rounded p-2">
          نام فایل: {{ fileName.length > 10 ? fileName.slice(0, 10) + '..' : fileName }} &nbsp; &nbsp; حجم فایل: {{ fileSize }}
          &nbsp; &nbsp;
          <i @click="deletefile()" class="fad fa-trash float-left text-danger"></i>
        </div>
      </div> -->

      <div class="col-12">
        <div class="Uploader Pointer text-center" @click="clickUploader()">
          <div class="row">
            <div class="col-7">
              <i class="fad fa-file-import fa-4x text-logo mt-3"></i>
              <i class="d-block mt-2 text-warning small" v-if="fileName == null">( کلیک کنید )</i>
              <i class="d-block mt-2 text-logo small" v-else>(برای بارگذاری دوباره، کلیک کنید)</i>
            </div>
            <div class="col-5">
              <div class="mt-5" v-if="fileName == null">فایل خود را بارگذاری کنید</div>
              <div class="mt-5" v-else>
                <div class="row text-right">
                  <div class="col-12 text-right my-2">
                    <small> نام فایل: {{ fileName.length > 10 ? fileName.slice(0, 10) + '..' : fileName }} </small>
                  </div>
                  <div class="col-12 text-right my-2">
                    <small> حجم فایل: {{ fileSize }} </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button class="btn btn-warning mt-2" v-if="fileName != ''" @click="deletefile()"><i class="fad fa-trash px-2"></i> حذف فایل</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fileName: '',
      fileSize: '',
      rnd: 0,
    }
  },
  methods: {
    clickUploader() {
      document.getElementById(this.rnd).click()
    },
    uploadfile() {
      this.fileName = document.getElementById(this.rnd).files[0].name
      this.fileSize = document.getElementById(this.rnd).files[0].size
      if (this.fileSize < 1024 * 1024) {
        this.fileSize = (this.fileSize / 1024).toFixed(1) + ' KB'
      } else {
        this.fileSize = (this.fileSize / (1024 * 1024)).toFixed(1) + ' Mb'
      }
      this.$emit('upload', document.getElementById(this.rnd).files[0])
    },
    deletefile() {
      document.getElementById(this.rnd).value = ''
      this.fileName = ''
      this.fileSize = ''
    },
  },
  created() {
    this.rnd = Math.floor(Math.random() * 2000)
  },
}
</script>
<style scoped>
.uploaderbox {
  width: 100%;
  border: 2px dashed var(--logo-color) !important;
  border-radius: 8px;
}
.uploaderbox:hover .fa-file-import {
  color: #0c6ec9 !important;
  transition: 0.3s;
}
i.small {
  font-size: 11px !important;
}
.Uploader {
  width: 100%;
  border: 2px dashed var(--logo-color) !important;
  border-radius: 8px;
  padding: 3px !important;
}
.Uploader:hover .fa-file-import {
  color: #0c6ec9 !important;
  transition: 0.3s;
}
</style>
